import { render } from "./GraphView.vue?vue&type=template&id=62dd2150"
import script from "./GraphView.vue?vue&type=script&lang=js"
export * from "./GraphView.vue?vue&type=script&lang=js"

import exportComponent from "/home/jhg/tagforest/tagforest-frontend-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__